import { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  MdDashboard,
  MdCategory,
  MdInventory,
  MdShoppingCart,
  MdPayment,
  MdReceiptLong,
  MdLogout,
} from 'react-icons/md';
import { api } from '../../../apis/api';
import './sidebar.css';
import logo from './../../../asstes/admin-logo.png';

const links = [
  { to: '/admin/dashboard', icon: <MdDashboard />, label: 'Dashboard' },
  { to: '/admin/categories', icon: <MdCategory />, label: 'Categories' },
  { to: '/admin/products', icon: <MdInventory />, label: 'Products' },
  { to: '/admin/orders', icon: <MdShoppingCart />, label: 'Orders', badgeKey: 'orders' },
  { to: '/admin/payment-status', icon: <MdPayment />, label: 'Payment Status', badgeKey: 'unpaid' },
  { to: '/admin/invoices', icon: <MdReceiptLong />, label: 'Invoice Details' },
];

export const AdminSidebar = () => {
  const navigate = useNavigate();
  const [badges, setBadges] = useState({ orders: 0, unpaid: 0 });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.getDashboard();
        if (cancelled) return;
        setBadges({
          orders: res.data?.pending_orders || 0,
          unpaid: res.data?.unpaid_orders || 0,
        });
      } catch (_) {
        /* ignore badge load errors */
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('sc_admin');
    navigate('/');
  };

  return (
    <aside className="admin-sidebar">
      <img className="logo-admin" src={logo} alt="SmartCrackers" />
      <nav className="admin-sidebar__nav">
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            className={({ isActive }) => `admin-sidebar__link${isActive ? ' active' : ''}`}
          >
            <span className="admin-sidebar__icon">{l.icon}</span>
            <span>{l.label}</span>
            {l.badgeKey && badges[l.badgeKey] > 0 && (
              <span className="admin-sidebar__badge">{badges[l.badgeKey]}</span>
            )}
          </NavLink>
        ))}
      </nav>
      <button type="button" className="admin-sidebar__logout" onClick={handleLogout}>
        <MdLogout /> Logout
      </button>
    </aside>
  );
};
